const GROUP = 'GROUP'
const SUBGROUP = 'SUBGROUP'
const MAIN = 'MAIN'
const LABEL = 'LABEL'
const FORMAT = new RegExp(
  '^(?=.*[!@#$%?£^&*"\\[\\]\\{\\}<>/\\(\\)=\\\\\\-´+`~\\:;,\\€\\|])'
)

const handleFieldForInputView = (
  handleOnChange,
  values,
  subgroup,
  allLanguages
) => {
  const fields = [
    {
      id: 'Label',
      isDisabled: false,
      isInvalid:
        subgroup === MAIN
          ? values.path.indexOf('.') !== -1 || /\s/g.test(values.path)
          : /\s/g.test(values.path),
      invalidText: getErrorMessage(values.path, 'LABEL', subgroup),
      value: values.path,
      type: 'text',
      customLabelText: 'Translations:LabelName',
      handleChange: (e) => {
        if (!FORMAT.test(e.target.value)) {
          return handleOnChange({
            path: e.target.value
          })
        }
      }
    },
    ...allLanguages.map((lang) => ({
      id: 'Label',
      labelText: lang,
      isDisabled: false,
      isInvalid: false,
      invalidText: '',
      value: values[lang],
      customLabelText: lang,
      type: 'text',
      handleChange: (e) => {
        return handleOnChange({
          [lang]: e.target.value
        })
      }
    }))
  ]
  return fields
}

const handleFieldForGroup = (handleOnChange, { path }) => {
  return [
    {
      id: 'path',
      isDisabled: false,
      isInvalid: path.indexOf('.') !== -1 || /\s/g.test(path),
      invalidText: getErrorMessage(path),
      name: 'Path',
      value: path,
      type: 'text',
      customLabelText: 'Translations:SectionName',
      handleChange: (e) => {
        return handleOnChange({
          path: e.target.value
        })
      }
    }
  ]
}
const handleFieldForSubGroup = (handleOnChange, { path }) => {
  return [
    {
      id: 'path',
      isDisabled: false,
      isInvalid: path.indexOf('.') !== -1 || /\s/g.test(path),
      invalidText: getErrorMessage(path),
      value: path,
      type: 'text',
      customLabelText: 'Translations:SubSectionName',
      handleChange: (e) => {
        return handleOnChange({
          path: e.target.value
        })
      }
    }
  ]
}

export const handleFormFields = (
  handleOnAddChange,
  newValue,
  type,
  subgroup,
  allLanguages
) => {
  if (type === GROUP) {
    return handleFieldForGroup(handleOnAddChange, newValue)
  } else if (type === SUBGROUP) {
    return handleFieldForSubGroup(handleOnAddChange, newValue)
  } else {
    return handleFieldForInputView(
      handleOnAddChange,
      newValue,
      subgroup,
      allLanguages
    )
  }
}

export const buildPayloadByType = (
  values,
  type,
  group,
  subgroup,
  allLanguages
) => {
  if (type === GROUP || type === SUBGROUP) {
    return {
      updates: [
        {
          langCode: localStorage.getItem('i18n-lang'),
          path: type === SUBGROUP ? `${group}.${values.path}` : values.path,
          translation: '',
          root: true
        }
      ]
    }
  } else {
    const subGroup = subgroup === MAIN ? '' : `.${subgroup}`
    const updates = allLanguages.reduce((acc, lang) => {
      return [
        ...acc,
        {
          langCode: lang,
          path: `${group}${subGroup}.${values.path}`,
          translation: values[lang] || ''
        }
      ]
    }, [])

    return {
      updates
    }
  }
}

const getErrorMessage = (str, type, subgroup) => {
  if (type === LABEL && subgroup === MAIN) {
    if (str.indexOf('.') !== -1) {
      return 'Translations:DotsErrorInMain'
    }
  }
  if (type !== LABEL) {
    if (str.indexOf('.') !== -1) {
      return 'Translations:DotsError'
    }
  }
  if (/\s/g.test(str)) {
    return 'Translations:SpacesError'
  }
}

export const processSubmitErrors = (str, type, subgroup) => {
  if (type === LABEL) {
    if (subgroup === MAIN) {
      return /\s/g.test(str) || str.indexOf('.') !== -1
    } else {
      return /\s/g.test(str)
    }
  } else {
    return str.indexOf('.') !== -1 || /\s/g.test(str)
  }
}

export const getModalName = (type) => {
  return type === LABEL
    ? 'Translations:AddNewLabel'
    : type === GROUP
    ? 'Translations:AddNewSection'
    : 'Translations:AddNewSubsection'
}
